import { render, staticRenderFns } from "./PersonProfileMasterAddLocation.vue?vue&type=template&id=2c07f06d&scoped=true&"
import script from "./PersonProfileMasterAddLocation.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterAddLocation.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileMasterAddLocation.vue?vue&type=style&index=0&id=2c07f06d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07f06d",
  null
  
)

export default component.exports